import { ReactNode } from 'react';
import './ConsoleNavMenu.css';

function SettingsHeader(): ReactNode {

    function goHome() {
        window.location.href = "/";
    }

    return (
        <header className='header'>
            <div className='console-nav-menu t-big'>
                <div className='header-box logo-box cursor-pointer' onClick={() => goHome()}>Air-link Console</div>
            </div>
        </header>
    )
}

export default SettingsHeader;